<template>
  <div
    v-if="text || $slots.default"
    class="field__description"
  >
    <slot />
    <p
      v-if="!$slots.default"
      v-html="text"
      class="field__description"
    />
  </div>
</template>

<script>

export default {
  name: 'InputfieldDescription',
  props: {
    text: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
